<template>
  <el-dialog class="my-dialog-template" :title="formType == 'long' ? '续期跟进备注' : '续保跟进备注'" :visible.sync="visible" width="600px" append-to-body>
    <el-form :inline="true" :model="formData" label-width="80px" ref="myForm" label-position="left" class="my-form-template">
      <el-form-item label="放弃续保" prop="isRenewal" class="full" v-if="formType == 'short' && rowData.productIsRenewal == 1">
        <el-radio-group v-model="formData.isRenewal">
          <el-radio label="0" :disabled="disabled">是</el-radio>
          <el-radio label="1" :disabled="disabled">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="renewalRemark" class="full">
        <el-input v-model="formData.renewalRemark" type="textarea" :autosize="{ minRows: 4 }"></el-input>
      </el-form-item>
    </el-form>
    <div class="modal-btn-list">
      <el-button type="warning" plain @click="visible = false">取消</el-button>
      <el-button type="warning" @click="submit()">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { ruleTool } from '@/api/mixins';
export default {
  mixins: [ruleTool],
  props: {
    // long-长险 short-短期险
    formType: null
  },
  data() {
    return {
      visible: false,
      disabled: false,
      formData: {},
      rowData: {}
    };
  },
  mounted() {},
  methods: {
    open(rowData) {
      this.rowData = rowData;
      this.formData = {
        id: rowData.id,
        isRenewal: typeof rowData.isRenewal == 'number' ? rowData.isRenewal.toString() : '1',
        renewalRemark: rowData.renewalRemark
      };
      // 续保成功和不可续保，放弃续保这个字段仅回显，不允许编辑
      this.disabled = rowData.isRenewal == 0 || rowData.renewalStatus == 5;
      this.visible = true;
    },
    submit() {
      this.$refs.myForm.validate(valid => {
        if (valid) {
          console.log(this.rowData.isRenewal , this.formData.isRenewal);
          if (this.rowData.isRenewal == 1 && this.formData.isRenewal == 0) {
            this.$confirm('请问是否确认放弃续保，放弃续保后此保单会展示在不可续保分类下。', '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.submitAjax();
            });
          } else {
            this.submitAjax();
          }
        } else {
          this.$message.error('请输入正确的信息');
        }
      });
    },
    submitAjax() {
      const formData = Object.assign({}, this.formData);
      if (this.formType == 'long' || this.rowData.productIsRenewal == 0) {
        // 长险或者产品配置了不可续保，则不传参
        delete formData.isRenewal;
      }
      this.$http({
        url: '/master/policy/updatePolicy',
        type: 'put',
        params: formData
      }).then(data => {
        this.$message.success('操作成功');
        this.visible = false;
        this.$emit('reload');
      });
    }
  }
};
</script>
<style lang="scss"></style>
